import React from 'react';

import './App.css';
import Knackroutes from './Routes/knackroutes';
import "../src/components/helpers/sidestyles.css"
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { FeatureLimitsProvider } from './components/FeatureLimits/FeatureLimitsProvider';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const queryClient = new QueryClient();
function App() {
  return (

    <div>
      <QueryClientProvider client={queryClient}>
        <FeatureLimitsProvider>
          <Knackroutes />
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </FeatureLimitsProvider>
      </QueryClientProvider>
    </div>

  );
}

export default App;
